import React from 'react';

import DocumentsPageGroup from './components/DocumentsPageGroup';
import HelpPageGroup from './components/HelpPageGroup';
import OverviewPageGroup from './components/OverviewPageGroup';
import RiskPageGroup from './components/RiskPageGroup';
import { PageGroupContainer } from './PageGroup.styles';

interface PageGroupProps {
  isExpanded: boolean;
}

const PageGroup = ({ isExpanded }: PageGroupProps) => {
  return (
    <PageGroupContainer $isExpanded={isExpanded}>
      <OverviewPageGroup isExpanded={isExpanded} />
      <RiskPageGroup isExpanded={isExpanded} />
      <DocumentsPageGroup isExpanded={isExpanded} />
      <HelpPageGroup isExpanded={isExpanded} />
    </PageGroupContainer>
  );
};

export default PageGroup;
